// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/hotel/hotel_availability_info.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_feature_hotel_pricing_info } from "./pricing_info_pb";
import { file_proto_model_feature_hotel_booking_urgency } from "./booking_urgency_pb";

/**
 * Describes the file proto/model/feature/hotel/hotel_availability_info.proto.
 */
export const file_proto_model_feature_hotel_hotel_availability_info = /*@__PURE__*/
  fileDesc("Cjdwcm90by9tb2RlbC9mZWF0dXJlL2hvdGVsL2hvdGVsX2F2YWlsYWJpbGl0eV9pbmZvLnByb3RvEgZjYXJtZW4i0AEKFUhvdGVsQXZhaWxhYmlsaXR5SW5mbxIqCg1leGFjdF9wcmljaW5nGAEgASgLMhMuY2FybWVuLlByaWNpbmdJbmZvEhcKD3Jvb21zX2F2YWlsYWJsZRgCIAEoBRInCgd1cmdlbmN5GAMgASgLMhYuY2FybWVuLkJvb2tpbmdVcmdlbmN5EhcKD2luc3RhbnRfYm9va2luZxgEIAEoCBIwCgxob2xkX2V4cGlyZXMYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wQjZaNGdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL2ZlYXR1cmUvaG90ZWxiBnByb3RvMw", [file_google_protobuf_timestamp, file_proto_model_feature_hotel_pricing_info, file_proto_model_feature_hotel_booking_urgency]);

/**
 * Describes the message carmen.HotelAvailabilityInfo.
 * Use `create(HotelAvailabilityInfoSchema)` to create a new message.
 */
export const HotelAvailabilityInfoSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_hotel_availability_info, 0);

